<script>
    import { t } from '$lib/i18n.js';
    import { page } from '$app/stores';
    import Button from '$lib/atoms/Button.svelte';
</script>

<section>
    <h2>{$t('routes.home.auting_values.title')}</h2>
    <div class="row">
        <div class="col">
            <img src="https://assets.auting.it/images/photos/map.webp" alt="" />
            <h3>{$t('routes.home.auting_values.cols.1.headline')}</h3>
            <p>{$t('routes.home.auting_values.cols.1.text')}</p>
        </div>
        <div class="col">
            <img src="https://assets.auting.it/images/photos/friends.webp" alt="" />
            <h3>{$t('routes.home.auting_values.cols.2.headline')}</h3>
            <p>{$t('routes.home.auting_values.cols.2.text')}</p>
        </div>
    </div>
    <Button label={$t('routes.home.auting_values.cta')} href="/{$page.params.lang}/driver" />
</section>

<style>
    section {
        display: flex;
        flex-direction: column;     
        align-items: center;
        justify-content: center;
        gap: 24px;
        padding: 1rem 2rem;
        padding-top: 120px;
        padding-bottom: 100px;
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        gap: 40px;
        max-width: var(--max-width);
        width: 100%;
        margin: 0 auto;
    }

    .col {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        flex: 1;
    }

    img {
        height: 330px;
    }

    h3 {
        font-family: var(--font-body);
        text-align: center;
        margin: 0;
        padding: 0;
        margin-top: 24px;
    }

    p {
        text-align: center;
        margin: 0;
        padding: 0;
    }

    h2 {
        text-align: center;
    }

    @media (max-width: 768px) {
        .row {
            flex-direction: column;
            align-items: center;
        }

        .col {
            flex-direction: column;

        }

        img {
            height: auto;
            width: 100%;
        }
    }
</style>